module.exports = __webpack_public_path__ + "img/warning_error.a72eb402.svg";